<template lang="pug">
ul.form-list(v-if="fieldsData" data-app)
  li.block(v-for="(form, i) in fieldsData" :key="form.id")
    .block__title {{form.title}}
    .block__about.about(v-show="form.description") {{form.description}}
    ul.block__content.items
      li.item(v-for="(item, j) in form.value" :key="item.key")
        .item__title {{item.title}}
        .item__about.about(v-show="item.description") {{item.description}}
        ul.item__content.sub-items(v-if="item.value")
          .sub-item(v-for="(subItem, k) in item.value" :key="`${i}${j}${k}`")
            SchoolForm(v-if="subItem.type === 'school'"
              v-bind="subItem"
              :eventTo="eventTo"
              :eventFrom="eventFrom"
              :ref="el => inputEls[(countInputNumbers())]=el"
            ) 
            MyInput(v-else v-bind="subItem" 
              :ref="el => inputEls[(countInputNumbers())]=el"
            )
</template>

<script>
import MyInput from './MyInput'
import SchoolForm from './SchoolForm'

import { warn } from '@/utils/msg'

export default {
  components: { MyInput, SchoolForm },
  props: {
    eventTo: {
      type: String,
      default: ''
    },
    eventFrom: {
      type: String,
      default: ''
    },
    fieldsData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      inputEls: []
    }
  },
  computed: {
  },
  methods: {
    async validate(){
      await Promise.all(
        this.inputEls.map((e) => {
          const { validate, type } = e
          return delayToDo([validate])
        })
      )
      await delay()
      const results = this.inputEls.map(e => e.validate())
      return results
    },
    async emitFormData() {
      const validateList = await this.validate()
      if (validateList.includes(false)) {
        await delay(250)
        warn('請檢查表單')
        return
      }
      const res = this.inputEls.map(e => {
        const { title, value, type } = e
        if(type === 'school') {
          return { value: e.apiValue }
        }
        return { title, value }
      })
      return res 
    },
    countInputNumbers() {
      return this.inputEls.length
    }
  }
}

function delay(time = 0) { return new Promise((resolve) => setTimeout(resolve, time)) }

async function delayToDo(CBList, payloadList) {
  try {
    for (let i = 0; i < CBList.length; i++) {
      await delay()
      if (!CBList[i]) return
      payloadList
        ? CBList[i](payloadList[i])
        : CBList[i]()
    }
  } catch(err) {
    console.error(err)
  }
}   
</script>

<style lang="sass" scoped>
.about
  box-sizing: border-box
  padding: 15px
  border-radius: 6px
  font-size: 14px
  margin-block-end: 40px
  position: relative
  border: 1px solid rgba(black, 0.2)
  text-align: left
  &::after
    letter-spacing: 1px
    color: rgba(85,85,85,.7)
    background-color: white
    padding-inline: 8px
    content: 'about'
    position: absolute
    top: -10px
    left: 50%
    transform: translateX(-50%)
.form-list
  margin-top: 50px
.block
  padding: 50px 40px 20px
  border-radius: 4px
  box-shadow: 0 0 3px 3px #eaeaea
  position: relative
  margin-block-end: 40px
  &__title
    position: absolute
    display: inline-block
    padding: 10px
    opacity: 0.9
    background-color: #ababab
    transform: rotate(-10deg)
    color: white
    top: 20px 
    left: -15px
    z-index: 1
    &::after
      transform: rotate(10deg)
      position: absolute
      content: ''
      border-top: 2px solid transparent
      border-bottom: 7px solid transparent
      border-right: 11px solid rgba(black,0.5)
      opacity: 1
      bottom: -8px
      left: -1px
      z-index: 2
  &__content
    margin-top: 40px
  .item
    margin-bottom: 40px
    border: 1px solid rgba(black, 0.2)
    border-radius: 6px
    padding: 40px 30px 20px
    position: relative
    &__title
      text-align: center
      padding-inline: 10px
      color: #777
      font-size: 15px
      position: absolute
      top: -10px
      left: 50%
      transform: translate(-50%, 0)
      background-color: #fff
      min-width: 100px
      z-index: 2
</style>



// WEBPACK FOOTER //
// src/views/ApplicationForm/MyFormBlocks.vue